const selector = '.js-audioplayer';

export const initPlayer = wrap => {
  const player = wrap.querySelector('.js-audioplayer-player');
  const playBtn = wrap.querySelector('.js-audioplayer-play');
  const seekBar = wrap.querySelector('.js-audioplayer-seek');
  const volumeBar = wrap.querySelector('.js-audioplayer-volume');
  const muteBtn = wrap.querySelector('.js-audioplayer-mute');
  const time = wrap.querySelector('.js-audioplayer-time');
  const allPlayer = document.querySelectorAll('.js-audioplayer-player');

  const togglePlay = () => {
    toggleLabel(playBtn);

    if (player.paused === false) {
      player.pause();
      wrap.classList.remove('is-playing');
      wrap.classList.add('is-paused');
    } else {
      allPlayer.forEach(item => {
        item.pause();
      });
      player.play();
      wrap.classList.remove('is-paused');
      wrap.classList.add('is-playing');
    }
  };

  const toggleLabel = (el) => {
    const label = el.getAttribute('aria-label');
    const toggleLabel = el.dataset.label;
    el.setAttribute('aria-label', toggleLabel);
    el.dataset.label = label;
  }

  const calcTime = () => {
    const min = parseInt(player.currentTime / 60) % 60;
    const secLong = player.currentTime % 60;
    const sec = secLong.toFixed();
    return `${min < 10 ? `0${min}` : min}:${sec < 10 ? `0${sec}` : sec}`;
  };

  const toggleMute = () => {
    const volume = (player.volume > 0) ? 0 : 1;
    player.volume = volume;
    volumeBar.value = volume;
    toggleLabel(muteBtn);
  };

  const timeupdate = () => {
    seekBar.value = (player.currentTime / player.duration).toFixed(2) * 100;
    time.innerHTML = calcTime();
  };

  player.onended = () => {
    wrap.classList.remove('is-playing');
    wrap.classList.add('is-paused');
    seekBar.setAttribute('value', 0);
    time.innerHTML = '00:00';
  };

  player.addEventListener('timeupdate', timeupdate);
  playBtn.addEventListener('click', togglePlay);
  muteBtn.addEventListener('click', toggleMute);

  seekBar.addEventListener('change', () => {
    player.currentTime = player.duration / 100 * seekBar.value;
    timeupdate();
  });

  volumeBar.addEventListener('change', () => {
    player.volume = volumeBar.value;
  });

  wrap.classList.add('is-initialized');
}

const intersection = new IntersectionObserver(el => {
  el.forEach(item => {
    if (item.isIntersecting) {
      intersection.unobserve(item.target)
      initPlayer(item.target)
    }
  })
});

if (document.querySelector(selector) !== null) {
  const player = document.querySelectorAll(selector);

  player.forEach(el => {
    intersection.observe(el)
  });
}
